import { useState, useEffect, useRef } from 'react';
import { fetchEvents } from '../services/eventsService';

const useRssFeed = (lang, limit = 9) => {
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    setLoading(true);
    setError(null);

    fetchEvents(lang, limit)
      .then(data => {
        if (!mounted.current) return;
        setItems(data);
        setLoading(false);
      })
      .catch(err => {
        if (!mounted.current) return;
        setError(err);
        setLoading(false);
      });

    return () => { mounted.current = false; };
  }, [lang, limit]);

  return { items, loading, error };
};

export default useRssFeed;
